// When the page loads, there may be applied options that are not in the
// fetched list, so we manually add them.
export const combineFetchedOptionsWithCurrentOptions = (
    fetchedOptions: any[],
    currentSelection: any | null | undefined | any[]
): any[] => {
    let selection = currentSelection || [];

    if (!Array.isArray(selection)) {
        selection = [selection];
    }

    const appliedOptionsNotInFetchedOptions = selection.filter(
        // @ts-expect-error
        (currentOption) =>
            !fetchedOptions.find(
                (fetchedOption) => currentOption && fetchedOption.id === currentOption.id
            )
    );

    return fetchedOptions.concat(appliedOptionsNotInFetchedOptions);
};
